import { TPoint } from '../../../points/points.model';
import { TColumn } from '../columns/column.model';
import { sortLength } from './sort-length';
import { sortTitle } from './sort-title';
import { sort } from './sorting';

export function sortAssignees(
  firstPoint: TPoint,
  secondPoint: TPoint,
  sortColumns: Partial<TColumn>[],
  index: number,
): number {
  const result = sortLength(firstPoint, secondPoint, sortColumns, index, {
    property: 'assignees',
  });

  if (result) {
    return result;
  }

  if (sortColumns[index + 1]) {
    return sort(firstPoint, secondPoint, sortColumns, index + 1);
  } else {
    return sortTitle(firstPoint, secondPoint, sortColumns, index);
  }
}
